import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewDensityNarrowIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewDensityNarrow" ref={ref} {...props}>
    <path d="M5,12.752H19A1.752,1.752,0,0,0,20.749,11V9.3a2.053,2.053,0,0,0-2.05-2.05H5A1.752,1.752,0,0,0,3.249,9v2A1.758,1.758,0,0,0,5,12.752ZM4.749,9A.248.248,0,0,1,5,8.752H18.7a.555.555,0,0,1,.55.55V11a.248.248,0,0,1-.25.25H5a.248.248,0,0,1-.25-.25ZM3.3,3a.749.749,0,0,1,.75-.75h16a.75.75,0,0,1,0,1.5h-16A.755.755,0,0,1,3.3,3ZM20.8,21a.748.748,0,0,1-.75.75h-16a.75.75,0,0,1,0-1.5h16A.743.743,0,0,1,20.8,21Zm0-4a.748.748,0,0,1-.75.75h-16a.75.75,0,0,1,0-1.5h16A.743.743,0,0,1,20.8,17Z" />
  </Icon>
)) as IconWithRender;

ViewDensityNarrowIcon.displayName = 'ViewDensityNarrowIcon';
ViewDensityNarrowIcon.renderIcon = (props) => (
  <ViewDensityNarrowIcon {...props} />
);
export default ViewDensityNarrowIcon;
